import formatCurrency from "@utils/formatCurrency"

import useUser from "./useUser"

// Formats amounts in the service company's currency and locale. Until the user has loaded
// there is no company to format for, so the bare number comes back instead of a guessed currency.
export default function useCurrencyFormatters() {
    const { user } = useUser()

    const serviceCompany = user?.service_company

    return {
        formatCurrency: (value: number | string): string =>
            serviceCompany
                ? formatCurrency({
                      value: Number(value),
                      currencyCode: serviceCompany.currency_code,
                      languageCode: serviceCompany.language_code,
                  })
                : String(value),
    }
}
